var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.027 2.401a1.917 1.917 0 012.65.723v.001l4.405 7.995a1.917 1.917 0 01-1.678 2.87H3.596a1.917 1.917 0 01-1.678-2.87l4.405-7.996c.166-.3.409-.549.704-.723zM8 3.302a.75.75 0 00-.656.387l-4.406 8-.006.01a.75.75 0 00.656 1.124H12.412a.75.75 0 00.656-1.125l-.006-.01L8.656 3.69A.752.752 0 008 3.302z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.167 11.599a.833.833 0 11.515.765.827.827 0 01-.515-.765zM8 4.793a.84.84 0 01.833.88L8.5 10.04H7.493l-.326-4.367A.847.847 0 018 4.793z",
    fill: "#121314"
  })));
}
export default SvgMedium;